import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxTag } from './Tag'
import { TagProps } from './Tag'

interface AvatarBlokProps {
  blok: {
    title: TagProps['title']
    isBold: TagProps['isBold']
  } & SbBlokData
}

const Avatar: FC<AvatarBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxTag title={blok.title} isBold={blok.isBold} />
    </div>
  )
}

export default Avatar
